'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '../lib';

/**
 * A checkbox component based on Radix UI's Checkbox primitive.
 */
function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      className={cn(
        `
        outline-primary-300
        data-[state=checked]:bg-primary-700/95
        hover:bg-primary-500/20
        dark:hover:bg-primary-400/40
        hover:ring-primary-800/10
        hover:data-[state=checked]:bg-primary-800
        focus:border-primary-500/50
        focus:ring-primary-600
        focus:data-[state=checked]:bg-primary-500
        shadow-xs
        focus-visible:ring-ring/50
        aria-invalid:ring-destructive/20
        size-4
        ring-offset-primary-500/50
        dark:ring-offset-primary-100/50
        dark:aria-invalid:ring-destructive/40
        dark:aria-invalid:ring-destructive/40
        aria-invalid:border-destructive
        peer
        shrink-0
        cursor-pointer
        rounded-sm
        border border-gray-300
        text-white
        transition-all
        duration-500
        ease-in-out
        hover:ring-offset-2
        focus:outline-2
        focus:ring-1
        disabled:cursor-not-allowed
        disabled:opacity-50
        `,
        className
      )}
      data-slot="checkbox"
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className="
          flex items-center justify-center text-current transition-none
        "
        data-slot="checkbox-indicator"
      >
        <CheckIcon className="size-3" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
